import Vue from 'vue';
import axios from 'axios';
import qs from 'qs'
// import store from '@/assets/store'
import Encrypt from '@/assets/until'

Vue.prototype.$axios = axios;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'; // 配置请求头
axios.defaults.timeout = 60000; // 请求超时
// http request 拦截器 传token
axios.interceptors.request.use(config => {
        // if (store.state.islogin) {
        //     return 1
        // }
        config.headers.token = '123456789'
            // config.headers.keyId = 'daac4c0b5d5bb4d86e59f9d1705425dd'
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
// response拦截器
axios.interceptors.response.use(response => {
    console.log(response, 'response')
    // 根据需要对返回数据进行处理
    if (response.data.isSuccess < 1 || response.config.url == 'http://datanal.cl086.com/prod-api/version/listHistory') {
        console.log(response, 'response111')
        // this.$message.error(response.data.errorMesg);
        return response;
    }
    return Promise.resolve(response)
}, error => {
    console.log(error, 'error')
    // 检查状态
    // switch (error.response.status) {
    //     case 402:
    //         // 清除token信息
    //         alert('登录过期，请重新登录')
    //             // 清除token信息
    //         localStorage.setItem('accessToken', '')
    //             // permissionUtil.logout()

    //         return error
    //     case 404:
    //         // 跳转404
    //         router.replace({
    //             path: '/404'
    //         })
    //         break
    // }
    return Promise.reject(error)
})
export default {
    post(url, params) {
        return new Promise((resolve, reject) => {
            let pardata = Encrypt.PublicEntryption(qs.parse(params))
            axios.post(url, pardata)
                .then(res => {
                    console.log(res)
                    if (res.data.reslutModel) {
                        let backdata = [];
                        backdata.push(Encrypt.PublicDecode(res.data.reslutModel));
                        backdata.push(res.data.thePage)
                        if (res.data.map) {
                            // 资讯分页
                            backdata.push(res.data.map)
                        }
                        resolve(backdata);
                    } else {
                        resolve(res);
                    }
                })
                .catch(err => {
                    reject(err.data)
                })
        });
    },
    get(url, params) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params
            }).then(res => {
                console.log(url)
                if (url === 'http://datanal.cl086.com/prod-api/version/listHistory') {

                    resolve(res);
                } else {
                    let backdata = [];
                    backdata.push(Encrypt.PublicDecode(res.data.reslutModel));
                    backdata.push(res.data.thePage)
                    resolve(backdata);
                }
            }).catch(err => {
                reject(err.data)
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/assets/http.js